import * as PIXI from "pixi.js";
import { Dictionary } from "../../util/collection/Dictionary";
import { Logger } from "../../util/log/Logger";
import { Renderer } from "../renderer/Renderer";
import { AssetManager } from "./AssetManager";
/**
 * SnapshotManager.ts
 */
export class SnapshotManager {
    constructor() {
        if (SnapshotManager.instance) {
            throw new Error("SnapshotManager Singleton Already Initialised");
        }
        this.create();
        SnapshotManager.instance = this;
    }
    create() {
        this.assetManager = AssetManager.getInstance();
        this.renderer = Renderer.getInstance().getRenderer();
        this.pendingSnapshots = new Dictionary();
        this.snapshots = new Dictionary();
        Logger.addObjectRef(this, "SnapshotManager");
    }
    clear() {
        this.snapshots.clear();
    }
    addTarget(name, target, options) {
        this.snapshots.setValue(name, this.createSnapshot(target, options));
    }
    addPendingTarget(name, target, options, onStart, onFinish) {
        this.pendingSnapshots.setValue(name, { target: target, options: options, onStart: onStart, onFinish: onFinish });
    }
    createSnapshot(target, options) {
        let position = new PIXI.Point(target.x, target.y);
        let pivot = new PIXI.Point(target.pivot.x, target.pivot.y);
        target.y = target.x = 0;
        target.pivot.x = target.pivot.y = 0;
        let snapshot = this.clone(target, options);
        target.position.copyFrom(position);
        target.pivot.copyFrom(pivot);
        return snapshot;
    }
    getSnapshotSprite(key) {
        if (this.pendingSnapshots.containsKey(key)) {
            const pending = this.pendingSnapshots.getValue(key);
            this.pendingSnapshots.remove(key);
            (typeof pending.onStart === "function") && pending.onStart();
            this.snapshots.setValue(key, this.createSnapshot(pending.target, pending.options));
            (typeof pending.onFinish === "function") && pending.onFinish();
        }
        return this.snapshots.getValue(key);
    }
    getSnapshot(properties, portraitProperties) {
        let snapshotLandscape = this.getSnapshotSprite(properties?.id);
        let snapshotPortrait = this.getSnapshotSprite(portraitProperties?.id);
        if (snapshotLandscape) {
            properties.sprite = PIXI.Sprite.from(snapshotLandscape.texture);
        }
        if (snapshotPortrait) {
            portraitProperties.sprite = PIXI.Sprite.from(snapshotPortrait.texture);
        }
    }
    clone(target, options, position, scale) {
        const texture = this.renderer.generateTexture(target, options);
        let sprite = new PIXI.Sprite(texture);
        if (scale) {
            sprite.scale.copyFrom(scale);
        }
        if (position) {
            sprite.position.copyFrom(position);
        }
        return sprite;
    }
    static getInstance() {
        if (SnapshotManager.instance === null) {
            SnapshotManager.instance = new SnapshotManager();
        }
        return SnapshotManager.instance;
    }
}
SnapshotManager.instance = null;
//# sourceMappingURL=SnapshotManager.js.map